import { render, staticRenderFns } from "./StarterPackHeader.vue?vue&type=template&id=27367db3&scoped=true"
import script from "./StarterPackHeader.vue?vue&type=script&lang=js"
export * from "./StarterPackHeader.vue?vue&type=script&lang=js"
import style0 from "./StarterPackHeader.vue?vue&type=style&index=0&id=27367db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27367db3",
  null
  
)

export default component.exports